<template>
  <div class="true-false" :class="wrapperClasses">
    <BaseLabel
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    />

    <div :class="controlClasses">
      <BaseTrueFalse
        :id="id"
        v-model="data"
        unused-class="{'float-right' : this.inline}"
        :error="error"
        false-text="Nie"
        true-text="Tak"
        :disabled="disabled"
        @input="emitEvent"
      />
      <div v-if="description || error" :class="descriptionClasses">
        <BaseControlDescription :id="id" :description="description" />
        <BaseControlError :id="id" :error="error" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import BaseTrueFalse from "@/components/Base/Controls/BaseTrueFalse";

export default {
  name: "TrueFalseControl",
  components: {
    BaseTrueFalse
  },
  extends: BaseFormControl,
  props: {
    value: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      data: this.value,
      controlOptions: {
        inlineDescriptionClass: "form__control-description"
      }
    };
  },
  computed: {}
};
</script>

<style lang="scss">
.true-false .form__control-description {
  padding-left: 0;
}
</style>
